var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero",class:[_vm.className]},[_c('div',{staticClass:"hero-overlay"},[_c('h1',{staticClass:"hero-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('h2',[_vm._v(" Rabbi Yechiel Eckstein"),_c('br'),_vm._v(" 1951 – 2019"),_c('br'),_vm._v(" "+_vm._s(_vm.subTitle)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }